import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi";
import { EntityResources, EntityResponse } from "~types/entity.ts";

type Props = {
  entityId?: string;
};

export const useFetchEntity = ({ entityId }:Props) => {
  const request = useApi();

  const { organizationId, sport } = useParams();

  const params = new URLSearchParams({
    limit: "1000",
    offset: "0",
    include: ["entityGroups"].join(","),
  });

  return useQuery({
    queryKey: ["entity", organizationId, entityId, sport],
    queryFn: async () => {
      const data = await request<EntityResponse>(`${sport}/o/${organizationId}/entities/${entityId}?${params.toString()}`);
      const resources: EntityResources | undefined = data?.includes?.resources;
      const entity = data?.data ? data.data[0] : null;
      return entity ? {...entity, entityGroup: resources?.[entity?.entityGroup?.resourceType ?? ""]?.[entity?.entityGroup?.id ?? ""]} : null;
    },
    enabled: !!entityId,
  });
};